const FurnaceInstallation = () => {
    return (
        <div>
            <section>
                <div className="about_banner_wepper only_big_hedding_set">
                    <img src="images/about-banner.png" alt="" />
                    <div className="about_content">
                        <h2>
                        Furnace Installation Company Denver Co</h2>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default  FurnaceInstallation;